module.exports = __webpack_public_path__ + "img/1-2.108d2bf2.svg";